import { FormControl, makeStyles } from '@material-ui/core'
import React, { FC, useEffect, useState } from 'react'
import { Select } from '@root-gipro/shared/FormElements'

const useStylesFormControl = makeStyles({
  root: {
    '& .MuiSelect-icon': {
      padding: 0,
      top: 'calc(50% - 12px)',
      color: 'rgba(0, 0, 0, 0.54)',
      right: 4,
      position: 'absolute',
      pointerEvents: 'none',
    },
  },
})

interface IAdminCompanySelect {
  setOA: (oaId: any) => void;
  objectsAnalog: any;
}

const OASelect: FC<IAdminCompanySelect> = ({ 
   setOA, 
   objectsAnalog
}) => {
  
  const classesFromControl = useStylesFormControl()
  const [oaSelectValues, setOaSelectValues] = useState([]);
  const [selectedValue, setSelectedValue] = useState<any>(null);
  const [selectedId, setSelectedId] = useState<string|null>(null);

  useEffect(() => {
    const arr: any = [];
    
    if(objectsAnalog?.length) {
        
      objectsAnalog.forEach((oa: any) => {
        if (oa?.id && oa?.name) {
          arr.push(`${oa.id} ${oa.name}`)
        }
      })
    }
    
    setOaSelectValues(arr);
  }, [objectsAnalog])

  useEffect(() => {
    if(selectedValue) {
      if(objectsAnalog?.length) {

        objectsAnalog.forEach((oa: any) => {
          if (`${oa.id} ${oa.name}` === selectedValue) {
            setSelectedId(oa.id);
          }
				})
      }
    }
  }, [selectedValue])

  useEffect(() => {
    if(selectedId) setOA(selectedId);
  }, [selectedId])

  return (
    <FormControl classes={classesFromControl}>
      <Select
        value={selectedValue}
        setValue={(fieldValue, value) => {
          setSelectedValue(value);
        }}
        fieldName={'qw'}
        items={oaSelectValues}
        disableCloseOnSelect={false}
      />
    </FormControl>
  )
}

export default OASelect
